import { FieldOption } from './accountTypes'

const sessionSaleFlags: FieldOption[] = [
  { value: 'fsp_alumni', name: 'FSP Alumni' },
  { value: 'tenured', name: 'Tenured' }
]

export default sessionSaleFlags
